var React = require('react');
var DropTarget = require('react-dnd').DropTarget;
var cx = require('classnames');
var PropTypes = require('prop-types');
var createReactClass = require('create-react-class');

var collect = (connect, monitor) => {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: false }),
        canDrop: monitor.canDrop(),
        itemType: monitor.getItemType()
    };
};

var dropTargetHandler = {
    drop(props) {
        return { dropIndex : props.dropIndex };
    }
};

var DropTargetContainer = createReactClass({
    propsTypes : {
        dropIndex : PropTypes.number
    },
    render() {

        var connectDropTarget = this.props.connectDropTarget;

        var classes = cx({
            'drop-target-container' : true,
            over : this.props.isOverCurrent,
            drop : this.props.canDrop
        });
        return connectDropTarget(
            <div className={classes}>
                {this.props.children}
            </div>
        );
    }
});
export default DropTarget(['source'],dropTargetHandler,collect)(DropTargetContainer);
